import _ from 'underscore';

let i18n = null;

export function initialize(options) {
  ({ i18n } = options);
}

export function mapEnumValueForFilter(enumType, enumValue) {
  return `Enum.${enumType}'${enumValue}'`;
}
// this map convers all mapping for exsing delivery status enums
// for each entity (adgroup/campaign/keyword/ad/else), it may only have several enum values
const DeliveryStatusToCategoryMap = {
  // Eligible
  Eligible: 0,
  New: 0,
  AdGroupAudienceAssociationPaused: 0,
  AdGroupAudienceAssociationExcluded: 0,
  AdGroupCriterionPaused: 0,
  AdGroupCriterionExcluded: 0,
  DSAAutoTargetProcessing: 0,

  // Eligible - Limited
  EditorialApprovedLimited: 1,
  EditorialApprovedLimitedAppealRejected: 1,
  EditorialApprovedMostAssetsDisapproved: 1,
  LowSupply: 1,
  LowQuality: 1,
  NegativeKeywordConflicts: 1,
  PartialNegativeKeywordConflicts: 1,
  DSAAutoTargetNegativeTargetConflict: 1,
  DSAAutoTargetBelowFirstPageBid: 1,
  BidBelowFirstPageBid: 1,
  BudgetSuggestions: 1,
  AutoBiddingLimitedByNotEnoughRevenue: 1,
  AutoBiddingLimitedByNotEnoughConversions: 1,
  AutoBiddingLimitedInventoryLimit: 1,
  AutoBiddingLimitedMaxCPCRestriction: 1,
  AutoBiddingLimitedBudgetRestriction: 1,
  AutoBiddingLimitedUnAttainableTarget: 1,
  AutoBiddingPortfolioBidStrategyTrainingStatus: 1,
  AutoBiddingLearning: 1,
  CampaignInReview: 1,
  CPSInsufficientConversions: 1,
  CPSAttributionBroken: 1,

  // Critical issues
  CreditCardExpired: 2,
  CampaignExpired: 2,
  IOExceeded: 2,
  PaymentInformationMissing: 2,
  InvalidFinancialStatusOther: 2,
  CampaignSuspended: 2,
  CampaignBudgetPaused: 2,
  DomainLanguageNotSupported: 2,
  AdGroupExpired: 2,
  AssetGroupExpired: 2,
  EditorialRejected: 2,
  EditorialAppealRejected: 2,
  CampaignDeleted: 2,
  StoreIdNotAssociated: 2,
  ShoppingCampaignStoreNotFound: 2,
  ShoppingCampaignNoOffersPresent: 2,
  AdGroupTargetingTooNarrow: 2,

  // Not Eligible
  CampaignInProgress: 3,
  CampaignUserPaused: 3,
  AssetGroupUserPaused: 3,
  AdGroupUserPaused: 3,
  AdGroupDraft: 3,
  AdUserPaused: 3,
  EditorialPending: 3,
  AdGroupPrivacyPending: 3,
  AssociationDeleted: 3,
  KeywordUserPaused: 3,
  EditorialUnderAppeal: 3,
  UrlInvalid: 3,
  ApplicationNotFound: 3,
  ApplicationDestinationUrlMismatch: 3,
  PendingMetadataSync: 3,
  ProductTargetUserPaused: 3,
  AdExtensionDeleted: 3,
  AdExtensionAssociationDeleted: 3,
  AdNotPresent: 3,
  AdNotActive: 3,
  NoEligibleAdGroups: 3,
  NoEligibleAds: 3,
  NoEligibleKeywords: 3,
  DSAAutoTargetUserPaused: 3,
  DSAAutoTargetNoMatchingLandingPage: 3,
  CPSNonRetailDomain: 3,
  AudienceTooNarrow: 3,
  LinkedInAccountServingHold: 3,
  LinkedInCompanyPagePaidMediaRequired: 3,
  AdNotServingExpiredCountdown: 3,
};

/**
 * Map delivery status input enum set to related category for the filter values to render
 *
 * @param {Array} enumSet - the enums that are valid for specific entity (like campaign)
 * @returns {Object} the configs(groupedItems, localized) needed by component/filter
 * to render in category type for delivery status.
*/
function getDeliveryStatusCategoryForFilter(enumSet) {
  const groupedItems = [];
  const enumSetToUse = _.uniq(enumSet);
  const localized = {};

  const categoryEnumValuesMap =
    _.groupBy(enumSetToUse, enumValue => DeliveryStatusToCategoryMap[enumValue]);

  _.each(categoryEnumValuesMap, (enumValues, category) => {
    const mappedValues = _.map(enumValues, value => ({
      value: mapEnumValueForFilter('DeliveryStatus', value),
      localized: i18n.getString(`Label_DeliveryStatus_${value}`),
    }));
    const categoryName = `FilterLocalization_DeliveryStatusCategories_${category}`;
    const itemLocalized = _.object(_.pluck(mappedValues, 'value'), _.pluck(mappedValues, 'localized'));

    groupedItems.push({
      items: _.pluck(mappedValues, 'value'),
      localized: itemLocalized,
      name: categoryName,
    });

    localized[categoryName] = i18n.getString(categoryName);
    _.extendOwn(localized, itemLocalized);
  });

  return {
    groupedItems,
    localized,
  };
}

/**
 * Update delivery status setting for render it in category type in filter
 *
 * @param {Object} entitySchema - the option to update for filter
 * @param {Array} enumSet - the enums that are valid for specific entity (like campaign)
 * @returns {void}
*/
export function updateDeliveryStatusPropertyForFilter(entitySchema, enumSet) {
  const deliveryStatusProperty = entitySchema.properties.DeliveryStatus;

  // get configs needed for category type filter for delivery status
  // , using the allowed values for adgroup
  const { groupedItems, localized } = getDeliveryStatusCategoryForFilter(enumSet);

  // Delete enum properties to make delivery status not enum type anymore
  // (enum has more priority in component/filter than category)
  if (deliveryStatusProperty.enum && _.isArray(deliveryStatusProperty.enum)) {
    delete deliveryStatusProperty.enum;
  }
  _.extendOwn(deliveryStatusProperty, {
    groupedItems, localized, type: 'category', operators: ['in'],
  });
  return deliveryStatusProperty;
}

